// extracted by mini-css-extract-plugin
module.exports = {"list":"ShipSelection_list__CPt_y","label":"ShipSelection_label__QFhjr"};